import React, { useState, useEffect, CSSProperties } from "react";
import axios from "axios";
import { Button, Container, Table } from "react-bootstrap";
import { BounceLoader } from "react-spinners";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#36d7b7",
};

const AppAdmin = () => {
  const guages = [
    { name: "عيار 24", guage: 24 },
    { name: "عيار 21", guage: 21 },
    { name: "عيار 18", guage: 18 },
    { name: "عيار 12", guage: 12 },
    { name: "أونصة", guage: 756.4 },
    { name: "جنيه", guage: 168 },
  ];
  const [scrapedData, setScrapedData] = useState([]);
  const [btnClicked, setBtnClicked] = useState(false);
  const [buyPrice, setBuyPrice] = useState(0);
  const [sellPrice, setSellPrice] = useState(0);
  const [ouncePriceBuy, setOuncePriceBuy] = useState(0);
  const [ouncePriceSell, setOuncePriceSell] = useState(0);
  const currentDate = new Date();
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const formattedDate = currentDate.toLocaleDateString("ar-EG", options);

  useEffect(() => {
    handleClick();
  }, []);

  const handleClick = async () => {
    setBtnClicked(true);

    try {
      const response = await axios.post(
        "https://us-central1-ewallet-aly.cloudfunctions.net/scrapeData"
      );
      // const response = await axios.post('http://localhost:3001/scrape');

      let resultArr = response.data["message"];

      console.log("Scraping initiated:", resultArr);

      setScrapedData(resultArr);
      setBtnClicked(false);
      setBuyPrice(parseFloat(resultArr[0]));
      setSellPrice(parseFloat(resultArr[1]));
      let worldPriceBuy = resultArr[2].replace(",", "");
      let worldPriceSell = resultArr[3].replace(",", "");
      setOuncePriceBuy(parseFloat(worldPriceBuy));
      setOuncePriceSell(parseFloat(worldPriceSell));
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div style={{ overflowX: "hidden", fontFamily: "" }} dir="rtl" lang="ar">
      <Container style={{ margin: "5%" }}>
        <BounceLoader
          color="#36d7b7"
          loading={btnClicked}
          size={150}
          aria-label="Loading Spinner"
          data-testid="BounceLoader"
        />
        {btnClicked && (
          <h1 style={{ color: "#36d7b7" }}>يتم تحميل البيانات ....</h1>
        )}
        {!btnClicked && (
          <div>
            <h2>
              أسعار الذهب و الدولار{" "}
              <Button
                variant="warning"
                size="sm"
                style={{ margin: "10px" }}
                onClick={handleClick}
              >
                تحديث
              </Button>
            </h2>
            <p>{formattedDate}</p>
            {/* <hr/> */}
            <Table>
              <thead>
                <tr>
                  <th>العيار</th>
                  <th>الشراء منك</th>
                  <th>البيع لك</th>
                </tr>
              </thead>
              <tbody>
                {guages.map((aGuage, index) => (
                  <tr key={index}>
                    <td style={{ backgroundColor: index === 1 && "gold" }}>
                      {aGuage.name}
                    </td>
                    <td style={{ backgroundColor: index === 1 && "gold" }}>
                      {((buyPrice * aGuage.guage) / 24).toLocaleString(
                        "en-US",
                        { maximumFractionDigits: 2 }
                      )}
                    </td>
                    <td style={{ backgroundColor: index === 1 && "gold" }}>
                      {((sellPrice * aGuage.guage) / 24).toLocaleString(
                        "en-US",
                        { maximumFractionDigits: 2 }
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <br />

            <h3>الأسعار الدولية</h3>
            <Table>
              <thead>
                <tr>
                  <th>النوع</th>
                  <th>الشراء منك</th>
                  <th>البيع لك</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>أونصة</td>
                  <td>
                    {ouncePriceBuy.toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                    })}
                  </td>
                  <td>
                    {ouncePriceSell.toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                    })}
                  </td>
                </tr>
                <tr>
                  <td>جرام</td>
                  <td>
                    {(ouncePriceBuy / 31.1).toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                    })}
                  </td>
                  <td>
                    {(ouncePriceSell / 31.1).toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                    })}
                  </td>
                </tr>
                <tr>
                  <td style={{ backgroundColor: "#79a471" }}>دولار أمريكي *</td>
                  <td style={{ backgroundColor: "#79a471" }}>
                    {(buyPrice / (ouncePriceBuy / 31.1)).toLocaleString(
                      "en-US",
                      { maximumFractionDigits: 2 }
                    )}
                  </td>
                  <td style={{ backgroundColor: "#79a471" }}>
                    {(sellPrice / (ouncePriceSell / 31.1)).toLocaleString(
                      "en-US",
                      { maximumFractionDigits: 2 }
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
            <p>*سعر التحوط بناء على أسعار الذهب</p>
            <p>{scrapedData[4]}</p>
          </div>
        )}
      </Container>
    </div>
  );
};

export default AppAdmin;
